import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../../Components/Loading";
import Table from "../../Components/Applications/Table";
import PaymentModal from "../../Components/Applications/PaymentModal";
import Navbar from "../../Components/Navbar";
import Config from "../../Config";
import moment from "moment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Campaigns/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import EditDeviceModel from "../../Components/Campaigns/EditDeviceModel";
import SingleEntry from "../../Components/Campaigns/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { toast } from "react-toastify";
import ViewModel from "../../Components/Applications/ViewModel";
import { Field, Form, Formik } from "formik";
import ChangeOfArticleTable from "../../Components/Services/ChangeOfArticleTable";
import ChangeOfNameTable from "../../Components/Services/ChangeOfNameTable";
import ChangeOfCorrectionTable from "../../Components/Services/ChangeOfCorrectionTable";
import ChangeOfAddressTable from "../../Components/Services/ChangeOfAddressTable";

import OtherServiceViewModel from "../../Components/Services/ViewModel";
import { useTranslation } from "react-i18next";

const Applications = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openViewModel, setOpenViewModel] = useState(false);
  const [otherServicesViewModel, setOpenOtherServicesViewModel] =
    useState(false);
  const [makePaymentModel, setMakePaymentModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateStatusModel, setOpenUpdateStatusModel] = useState(false);
  const [assocId, setAssocId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [paymentApiData, setPaymentApiData] = useState(null);

  const [searchType, setSearchType] = useState("0");
  const [serviceType, setServiceType] = useState("0");

  const [editDevice, setEditDevice] = useState(false);

  const navigate = useNavigate();

  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  //console.log(startDate);
  // // ----- Getting Initial Data ------
  const fetchFunction = async (values) => {
    const body = new FormData();
    body.append("token", user.id);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", values.status);
    body.append("serviceType", values.serviceType);
    return await axios.post(`${Config.apiUrl}/myapplications`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
    if (res.data.status == "OK" && res.data.data == false) error = true;
  };

  const getError = (res) => {};

  const {
    isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    refetch,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    let values = {
      status: "0",
      serviceType: "0",
    };

    getAppRegMutate(values);
  }, []);

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    let filter = {
      status: searchType,
      serviceType: serviceType,
    };
    //refetch();
    getAppRegMutate(filter);
  };

  const searchHandler = (value) => {
    //setSearchType(value)
    let values = {
      status: value,
      serviceType: serviceType,
    };
    getAppRegMutate(values);
  };

  const serviceHandler = (value) => {
    //setServiceType(value)
    let values = {
      status: searchType,
      serviceType: value,
    };
    getAppRegMutate(values);
  };

  //------- Add Single Entry -------
  const SingleEntryPostFunction = async (values) =>
    await axios.post(
      `${Config.nodeApiUrl}/addSingleContact`,
      values,
      Config.AxiosConfig
    );

  const onSingleEntrySuccess = (res) => {
    refetch();
    setOpenUploadModel(false);
    toast.success(res?.data?.msg || "Success");
  };

  const onSingleEntryError = (res) => {
    setOpenUploadModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: SingleEntryLoading, mutate: postSingleEntry } =
    useMutation(SingleEntryPostFunction, {
      onSuccess: onSingleEntrySuccess,
      onError: onSingleEntryError,
    });

  //------- Get Payment Details  -------
  const paymentDetailPostFunction = async (values) => {
    const body = new FormData();
    body.append("userType", user.userType);
    if (values.serviceType != 0) {
      body.append("assocId", values.assocId);
      setAssocId(values.assocId);
    } else {
      body.append("assocId", values.id);
      setAssocId(values.id);
    }
    body.append("serviceType", values.serviceType);
    return await axios.post(`${Config.apiUrl}/getpaymentdetails`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onMakePaymentSuccess = (res) => {
    //setOpenUploadModel(false);
    if (res?.data?.status == "OK") {
      //values.assocId
      setPaymentApiData(res?.data.list);
      setMakePaymentModel(true);
    } else {
      toast.error(res?.data?.msg || "An Error Occured");
    }
    //toast.success(res?.data?.msg || "Success");
  };

  const onMakePaymentError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.data?.msg || "An Error Occured");
  };

  const { isLoading: makePaymentLoading, mutate: makePaymentMutate } =
    useMutation(paymentDetailPostFunction, {
      onSuccess: onMakePaymentSuccess,
      onError: onMakePaymentError,
    });

  //----Refetch Control No. -----------

  const refetchCNoApi = async (values) => {
    const body = new FormData();
    // body.append("assocId", values.id);
    // body.append("assocName", values.assocName);
    // body.append("userType", user.userType);
    body.append("billId", paymentApiData.billId);

    return await axios.post(`${Config.apiUrl}/refetchControlNo`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onRefetchCNoSuccess = (res) => {
    if (res?.data?.status == "OK") {
      setMakePaymentModel(false);
      toast.success(res?.data?.msg || "Success");
      //refetch();
    }
  };

  const onRefetchCNoError = (res) => {
    setMakePaymentModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: refetchCNoLoading, mutate: refetchCNoMutate } =
    useMutation(refetchCNoApi, {
      onSuccess: onRefetchCNoSuccess,
      onError: onRefetchCNoError,
    });

  // ----------------End---------------------

  return (
    <>
      <Navbar />
      <Page>
        {makePaymentModel && (
          <PaymentModal
            openMakePaymentModel={setMakePaymentModel}
            selectedItem={selectedItem}
            paymentApiData={paymentApiData}
            assocId={assocId}
            refetchCNoMutate={refetchCNoMutate}
            refetchCNoLoading={refetchCNoLoading}
          />
        )}

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("My_Requests")}</Title>
              <Underline />
            </div>

            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          <div className="flex flex-col space-y-6  lg:space-y-0 lg:flex-row lg:items-end lg:justify-end">
            {/* <Filters
              t={t}
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
            /> */}
            <div className="flex items-center space-x-8 mt-12 md:mt-8">
              <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
                <Label htmlFor="startDate">{t("Status")}</Label>

                {serviceType == 0 && (
                  <Select
                    autoComplete="off"
                    className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                    value={searchType}
                    style={{ height: "40px" }}
                    onChange={(e) => {
                      setSearchType(e.target.value);
                      searchHandler(e.target.value);
                    }}
                  >
                    <MenuItem value="0">All</MenuItem>
                    <MenuItem value="1">Pending Docs</MenuItem>
                    <MenuItem value="2">Pending Payments</MenuItem>
                    <MenuItem value="3">InProgress</MenuItem>
                    <MenuItem value="4">Approved By Asst</MenuItem>
                    <MenuItem value="5">Completed</MenuItem>
                    {/* <MenuItem value="6">Certificate Issued</MenuItem> */}
                    <MenuItem value="10">Rejected</MenuItem>
                  </Select>
                )}

                {serviceType != 0 && (
                  <Select
                    autoComplete="off"
                    className="w-36 pl-2 bg-transparent text-sm p-0 border-none"
                    style={{ height: "40px" }}
                    value={searchType}
                    onChange={(e) => {
                      setSearchType(e.target.value);
                      searchHandler(e.target.value);
                    }}
                  >
                    <MenuItem value="0">All</MenuItem>
                    <MenuItem value="2">Pending Payments</MenuItem>
                    <MenuItem value="3">InProgress</MenuItem>
                    <MenuItem value="4">Approved By Asst</MenuItem>
                    <MenuItem value="5">Completed</MenuItem>
                    <MenuItem value="6">Certificate Issued</MenuItem>
                    <MenuItem value="10">Rejected</MenuItem>
                  </Select>
                )}
              </InputGroup>
              <InputGroup className="w-full" style={{ flexBasis: "content" }}>
                <Label htmlFor="startDate">{t("Select_Service")}</Label>
                <Select
                  autoComplete="off"
                  className="w-48 pl-2 bg-transparent text-sm p-0 border-none"
                  style={{ height: "40px" }}
                  value={serviceType}
                  onChange={(e) => {
                    setServiceType(e.target.value);
                    serviceHandler(e.target.value);
                  }}
                >
                  {/* <MenuItem value="0">All</MenuItem> */}
                  <MenuItem value="0">App For Assoc Reg</MenuItem>
                  <MenuItem value="1">Correcting Constitution</MenuItem>
                  <MenuItem value="2">Change of Article</MenuItem>
                  <MenuItem value="3">Change of Name</MenuItem>
                  <MenuItem value="4">Change of Address</MenuItem>
                </Select>
              </InputGroup>
            </div>
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openUploadModel && (
            <SingleEntry
              postSingleEntry={postSingleEntry}
              SingleEntryLoading={SingleEntryLoading}
              setOpenUploadModel={setOpenUploadModel}
              groupId={id}
            />
          )}
          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              gTypeOfGame={gTypeOfGame}
            />
          )}

          {otherServicesViewModel && (
            <OtherServiceViewModel
              setOpenViewModel={setOpenOtherServicesViewModel}
              selectedItem={selectedItem}
              serviceType={serviceType}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              {serviceType == 0 && (
                <Table
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setSelectedItem={setSelectedItem}
                  setOpenUpdateStatusModel={setOpenUpdateStatusModel}
                  setOpenViewModel={setOpenViewModel}
                  //makePaymentModel={setMakePaymentModel}
                  makePaymentMutate={makePaymentMutate}
                />
              )}

              {serviceType == 1 && (
                <ChangeOfCorrectionTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  //makePaymentModel={setMakePaymentModel}
                  makePaymentMutate={makePaymentMutate}
                />
              )}

              {serviceType == 2 && (
                <ChangeOfArticleTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  //makePaymentModel={setMakePaymentModel}
                  makePaymentMutate={makePaymentMutate}
                />
              )}
              {serviceType == 3 && (
                <ChangeOfNameTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  //makePaymentModel={setMakePaymentModel}
                  makePaymentMutate={makePaymentMutate}
                />
              )}

              {serviceType == 4 && (
                <ChangeOfAddressTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  makePaymentModel={setMakePaymentModel}
                  makePaymentMutate={makePaymentMutate}
                />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({ t, initialValues, submitHandler, InitialLoading, user }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Start_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">{t("End_Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            {t("Date_filter")}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default Applications;
